import React from "react";

import { Navigate } from "react-router-dom";

import useDecodedParams from "Hooks/useDecodedParams";
import useSelectorWithUrlParams from "Hooks/useSelectorWithUrlParams";
import { environmentSelector } from "Reducers/environment";
import { useLoadDeploymentsCurrent } from "Reducers/environment/deployment/hooks";

type RedirectToFirstAppType = {
  mainEnvironmentId?: string;
};

const RedirectToFirstApp = ({ mainEnvironmentId }: RedirectToFirstAppType) => {
  const { environmentId, organizationId, projectId } = useDecodedParams<{
    environmentId?: string;
    organizationId: string;
    projectId: string;
  }>();
  const envId = environmentId || mainEnvironmentId;
  const environment = useSelectorWithUrlParams(environmentSelector, {
    environmentId: envId
  });

  const { currentDeployment, currentDeploymentError } =
    useLoadDeploymentsCurrent(
      { organizationId, projectId, environmentId: envId! },
      !!environment?.has_code
    );

  if (!currentDeployment && currentDeploymentError) {
    return <Navigate to="routes" />;
  }

  // environment is paused
  if (environment && !environment.has_deployment) {
    return <Navigate to="routes" />;
  }

  const apps = Object.keys(currentDeployment?.webapps || {});

  // apps are not loaded yet
  // let's wait until deployment is loaded
  if (!apps.length) {
    return null;
  }

  return <Navigate to={apps.length > 0 ? apps[0] : "routes"} />;
};

export default RedirectToFirstApp;
